import styled, { createGlobalStyle } from 'styled-components';
import { colors } from '../utils/colors';
import { Tooltip } from 'react-tooltip';

// Global style to ensure secondary text in tooltips is always grey
export const TooltipGlobalStyle = createGlobalStyle`
  /* Target react-tooltip's rendered structure */
  [role="tooltip"].tooltip-styled .tooltip-secondary-text,
  [role="tooltip"].tooltip-styled div.tooltip-secondary-text,
  [role="tooltip"] .tooltip-secondary-text,
  .react-tooltip.tooltip-styled .tooltip-secondary-text,
  div[class*="tooltip"] .tooltip-secondary-text {
    color: ${colors.grey400} !important;
  }
`;

// Styled components for tooltip content
export const TooltipContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TooltipMainText = styled.div`
  color: ${colors.white};
`;

export const TooltipSecondaryText = styled.div`
  color: ${colors.grey400} !important;
  font-size: 11px;
`;

// Define a styled tooltip with custom styles
export const StyledTooltip = styled(Tooltip)`
  &.tooltip-styled {  // Add a class name
    max-width: 300px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    background-color: ${colors.grey800};
    color: ${colors.white};
    padding: 12px;
    border-radius: 8px;
    opacity: 1; // Ensure the tooltip is fully opaque
    font-size: 12px;
    z-index: 9999 !important; // Ensure tooltip is always on top

    /* Ensure secondary text always stays grey */
    .tooltip-secondary-text {
      color: ${colors.grey400} !important;
    }
  }
`;